/**
 * @fileoverview Drop-in replacement for the UX table component on mobile.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import {Button} from '/ui/components/button/button';
import {Card} from '/ui/components/card/card';
import {ClickableDiv} from '/ui/components/clickable/clickablediv';
import {Types as TableTypes} from '/ui/components/table/table';

import * as styles from '/js/yext/externalaccounts/listingslaunch/styles/listingslaunchexternalaccounts.module.scss';

/**
 * See /ui/components/table/types.js for `?` type definitions.
 * @param {{
 *   label: string,
 *   columns: !Array<?>,
 *   dataRows: !Array<?>,
 *   rowSelectionOptions: (!TableTypes.RowSelectionOptions | undefined),
 *   handleAddNewAccount: function(string),
 *   linkAccountUrl: string,
 * }} props
 */
export function MobileCardTable({
  label,
  columns,
  dataRows,
  rowSelectionOptions,
  handleAddNewAccount,
  linkAccountUrl,
}) {
  return (
    <>
      <div className={styles.mobileAccountTableLabel}>{label}</div>
      {dataRows.map(row => (
        <ClickableDiv
          key={row.id}
          className={styles.mobileAccountCardContainer}
          onClick={() => rowSelectionOptions?.onSelectRow?.(row.id, false /* state */)}
        >
          <Card
            taskFlowStyle
            selected={rowSelectionOptions?.isSelected?.(row.id)}
            isDisabled={rowSelectionOptions?.isDisabled?.(row.id)}
          >
            <Card.Body>
              <div className={styles.mobileAccountCard}>
                {columns.map(column => (
                  <div key={column.id} className={styles.mobileAccountCardRow}>
                    <div className={styles.mobileAccountCardKey}>
                      {column.label}:
                    </div>
                    <div className={styles.mobileAccountCardValue}>
                      {row[column.id]}
                    </div>
                  </div>
                ))}
                {!row['isValid']
                  && <div className={styles.mobileRelinkButton}>
                    <Button onClick={() => handleAddNewAccount(linkAccountUrl)}>
                      {yext.msg('Relink Account')}
                    </Button>
                  </div>
                }
              </div>
            </Card.Body>
          </Card>
        </ClickableDiv>
      ))}
    </>
  );
}
